(() => {
  'use strict';
  const gallery = document.querySelector('.replica-gallery');
  if (gallery) {
    const slides = [...gallery.querySelectorAll('[data-slide]')];
    let active = 0;
    const show = (next) => {
      active = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== active;
        slide.setAttribute('aria-hidden', String(i !== active));
      });
      gallery.setAttribute('data-active-slide', String(active + 1));
    };
    document.getElementById('galPrev')?.addEventListener('click', () => show(active - 1));
    document.getElementById('galNext')?.addEventListener('click', () => show(active + 1));
    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        show(active + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });
    let touchStart = null;
    gallery.addEventListener('touchstart', (event) => { touchStart = event.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', (event) => {
      if (touchStart === null) return;
      const delta = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(delta) > 45) show(active + (delta < 0 ? 1 : -1));
      touchStart = null;
    }, { passive: true });
    show(0);
  }

  const rail = document.querySelector('.replica-testimonials');
  rail?.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    rail.scrollBy({ left: rail.clientWidth * (event.key === 'ArrowLeft' ? -1 : 1), behavior: 'smooth' });
  });

  const form = document.getElementById('product-form');
  const packs = document.getElementById('bedbugrx-packs');
  const button = document.getElementById('checkoutButton');
  const status = document.getElementById('checkoutError');
  const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  const say = (message) => { if (status) { status.textContent = message; status.hidden = false; } };
  const update = () => {
    if (!packs || !form) return;
    let selected = packs.querySelector('input[name="pack"]:checked:not(:disabled)');
    if (!selected) {
      selected = packs.querySelector('input[name="pack"]:not(:disabled)');
      if (selected) selected.checked = true;
    }
    packs.querySelectorAll('.mv-card').forEach(card => card.classList.toggle('is-checked', card.contains(selected)));
    if (!selected) { if (button) button.disabled = true; return; }
    const card = selected.closest('.mv-card');
    const price = Number(card.dataset.price);
    const compare = Number(card.dataset.compare);
    const hiddenVariant = form.querySelector('input[name="id"]');
    if (hiddenVariant) hiddenVariant.value = selected.value;
    const total = document.getElementById('totalValue');
    const compareEl = document.getElementById('totalCompare');
    const badge = document.getElementById('totalBadge');
    if (total) total.textContent = money(price);
    if (compareEl) { compareEl.textContent = money(compare); compareEl.hidden = compare <= price; }
    if (badge) { badge.textContent = `SAVE ${Math.round((compare - price) / compare * 100)}% OFF`; badge.hidden = compare <= price; }
    if (button) button.disabled = false;
    if (status) status.hidden = true;
  };
  packs?.addEventListener('change', update);
  update();

  // Select the card whose data-pack (device count) equals n: the same state change as the
  // shopper clicking that card. Counts with no matching, available card are ignored.
  const selectPack = (n, opts = {}) => {
    const count = Number.parseInt(n, 10);
    if (!packs || !count) return null;
    const card = [...packs.querySelectorAll('.mv-card')].find(c =>
      Number(c.dataset.pack) === count && !c.querySelector('input[name="pack"]')?.disabled);
    if (!card) return null;
    card.querySelector('input[name="pack"]').checked = true;
    update();
    if (opts.scroll) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return card;
  };
  // The bedroom selector dispatches 'hp:home-size' { pack, selection, quiz_id }
  // (same contract as the EComposer PDPs): select that pack and scroll to it.
  window.addEventListener('hp:home-size', (event) => {
    const detail = event.detail;
    if (detail && selectPack(detail.pack, { scroll: true })) detail.handled = true;
  });
  // ?pack=N (set by the lander's bedroom selector) preselects that pack on load, without scrolling.
  try {
    const packParam = new URLSearchParams(window.location.search).get('pack');
    if (packParam && /^\d+$/.test(packParam)) selectPack(packParam, { initial: true });
  } catch (_) {}

  // Bedrooms → pack (Matt, 2026-10-07): Studio/1 → 1 · 2 → 3 · 3–4 → 5 · 5+ → 10 (the input value).
  // GA4 home_size_complete fires once per page load, on the first selection.
  let homeSizeFired = false;
  document.querySelectorAll('#bedroomQuiz input').forEach(input => {
    input.addEventListener('change', () => {
      if (!input.checked) return;
      const quantity = Number(input.value);
      const recommendation = document.getElementById('brsec-rec');
      const output = document.getElementById('brsec-rec-text');
      if (output) output.textContent = `Recommended: ${quantity} ${quantity === 1 ? 'unit' : 'units'}`;
      recommendation?.classList.add('visible');
      const label = input.labels[0];
      const selection = input.dataset.selection || (label?.innerText || label?.textContent || '').replace(/\s+/g, ' ').trim();
      try {
        window.dispatchEvent(new CustomEvent('hp:home-size', { detail: { pack: quantity, selection, quiz_id: 'BedBugRx_pdp' } }));
      } catch (_) {}
      if (!homeSizeFired && typeof window.gtag === 'function') {
        homeSizeFired = true;
        try {
          window.gtag('event', 'home_size_complete', { quiz_id: 'BedBugRx_pdp', selection, recommendation: quantity });
        } catch (_) {}
      }
    });
  });

  // Same Stape event contract as the live RodentRx and refill pages.
  function _sstGetShopifyClientId() {
    var m = document.cookie.match(/(?:^|; )_shopify_y=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  /* onDone (optional): invoked once GTM finishes dispatching the event
     (eventCallback), so direct-checkout can navigate without racing the tag.
     Callers must still keep their own fallback timer — if GTM never loads,
     neither eventCallback nor eventTimeout ever fires. */
  function pushAddToCartStape(addResp, variantId, onDone) {
    // /cart/add.js response format: { items: [lineItem] } — unwrap before reading fields.
    var lineItem = (addResp && addResp.items && addResp.items.length > 0)
      ? addResp.items[0]
      : (addResp || {});
    var price = ((lineItem.price || 0) / 100).toFixed(2);
    var lineTotal = ((lineItem.line_price || lineItem.final_line_price || lineItem.price || 0) / 100).toFixed(2);
    var itemId = String(lineItem.product_id || '');
    var sku = lineItem.sku || '';
    var name = lineItem.product_title || lineItem.title || '';
    var qty = lineItem.quantity || 1;
    window.dataLayer = window.dataLayer || [];
    var payload = {
      event: 'add_to_cart_stape',
      user_data: {
        shopify_client_id: _sstGetShopifyClientId()
      },
      ecommerce: {
        value: lineTotal,
        currency: 'USD',
        items: [{
          item_id: itemId,
          item_variant: String(variantId),
          item_sku: sku,
          item_name: name,
          variant_name: lineItem.variant_title || '',
          item_category: lineItem.product_type || '',
          item_brand: lineItem.vendor || '',
          item_url: lineItem.url || '',
          price: price,
          imageURL: (lineItem.featured_image && lineItem.featured_image.url) ? lineItem.featured_image.url : (lineItem.image || ''),
          quantity: qty
        }]
      },
      cart_state: {
        cart_quantity: qty,
        cart_value: lineTotal,
        currency: 'USD',
        lines: [{
          item_variant: String(variantId),
          item_id: itemId,
          item_sku: sku,
          item_name: name,
          quantity: qty,
          line_total_price: lineTotal,
          price: price
        }]
      },
      ecomm_pagetype: 'other',
      actual_url: window.location.href
    };
    if (onDone) {
      var called = false;
      payload.eventCallback = function () { if (!called) { called = true; onDone(); } };
      payload.eventTimeout = 800;
    }
    window.dataLayer.push(payload);
  }

  let submitting = false;
  form?.addEventListener('submit', async event => {
    event.preventDefault();
    if (form.dataset.preview === 'true') {
      say('Preview only. Checkout becomes available when this page is connected to the BedBugRx product in Shopify.');
      return;
    }
    if (submitting) return;
    const selected = packs?.querySelector('input[name="pack"]:checked:not(:disabled)');
    if (!selected || !/^\d+$/.test(selected.value)) { say('Please choose an available pack.'); return; }
    const original = button.textContent;
    submitting = true; button.disabled = true; button.textContent = 'Adding...';
    let data;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: selected.value, quantity: 1 }] })
      });
      data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to add this pack. Please try again.');
    } catch (error) {
      say(error.message || 'Unable to add this pack. Please try again.');
      submitting = false; button.disabled = false; button.textContent = original;
      return;
    }
    // Analytics failure must not retry a successful cart write or prevent checkout.
    let navigated = false;
    const checkout = () => {
      if (navigated) return;
      navigated = true;
      window.clearTimeout(fallback);
      window.location.assign('/checkout');
    };
    const fallback = window.setTimeout(checkout, 1000);
    try { pushAddToCartStape(data, selected.value, checkout); } catch (_) { checkout(); }
  });
  document.querySelector('#ContactFooter[data-preview="true"]')?.addEventListener('submit', event => {
    event.preventDefault();
    let message = document.getElementById('newsletterPreviewStatus');
    if (!message) {
      message = document.createElement('p');message.id = 'newsletterPreviewStatus';message.setAttribute('role', 'status');event.currentTarget.append(message);
    }
    message.textContent = 'Preview only. Email signup is available on the Shopify page.';
  });
  if (!document.head.querySelector('link[rel="icon"]')) {
    const icon = document.createElement('link'); icon.rel = 'icon';
    icon.href = 'https://hellopest.org/cdn/shop/files/5_3f251262-fa8e-4493-bd39-536645b06d8b.png?width=32';
    document.head.append(icon);
  }
})();
